import { ComponentType } from '@angular/cdk/portal';

export interface ISidePanelConfiguration {
  component: ComponentType<any>;
  data?: any;
  closeOnEsc?: boolean;
  onClose?: (res: any) => Promise<any>;
}
